<template>
  <side-panel-inner headerTitle="Edit Group" class="p-group-create" on-close='Groups'>
    <template slot="actions">
      <base-button danger @click="deleteGroup">Delete</base-button>
      <base-button :primary="true" @click="updateGroup">Save</base-button>
    </template>

    <!-- Group Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <form v-if="!loading">
      <form-field full-width label="Group Name" name="group_name" v-model="group.name"></form-field>
    </form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
import GroupForm from "./GroupForm";
import { mapState } from "vuex";

export default {
  name: "group-edit",

  data() {
    return {
      showValidationMessage: false,
      loading: false,
      formReady: false
    };
  },

  beforeCreate() {
    const groupId = this.$route.params.groupId;

    this.$store.dispatch("InterestGroups/read", groupId).then(() => {
      this.formReady = true;
    });
  },

  methods: {
    updateGroup() {
      this.$store
        .dispatch("InterestGroups/update", {id: this.$route.params.groupId, groupData: this.group})
        .then(() => {
          this.$store.dispatch("CLOSE_PANEL");
        });
    },

    deleteGroup() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          vm.$store
            .dispatch("InterestGroups/delete", this.$route.params.groupId)
            .then(() => {
              vm.$store.dispatch("CLOSE_PANEL",'Groups');
            });
        }
      });
    }
  },

  computed: {
    ...mapState("InterestGroups", ["group"]),
    formIsValid() {
      return this.group.name;
    }
  },

  components: {
    GroupForm
  }
};
</script>
